/**
 * Created by andrey on 28.03.2024.
 */

const SamsungLogger = function () {
    this.config = {
        lifetime: "14 days"
    };
};

SamsungLogger.prototype.trackEvent = function (name, params) {
    if (typeof GSInstant === "undefined") {
        return;
    }

    GSInstant.logEvent(name, "string", JSON.stringify(params));
};

SamsungLogger.isApplicable = function () {
    return connector.platform.oneOf(connector.SAMSUNG);
};
